import React, { useState, useEffect } from "react";
import FeedbackRating from '../feedbackRating.js';
import { dataUser } from '../Component/Helpers/util';
import axios from 'axios';
import Sidebar from "../Component/Layout/Sidebar";
import CustomHeader from "../Component/Layout/Header";
import { Layout } from "antd";
import SwButton from "./Common/SwButtons/SwButtons";

const SurveyManagement = () => {
  const [surveyData, setSurveyData] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [activeSurveyIndex, setActiveSurveyIndex] = useState(null);

  const UserObj = JSON.parse(dataUser());
  const company_id = UserObj ? UserObj.company_id : null;

  const toggleCollapsed = () => {
    setCollapsed(prev => !prev);
  };

  const getSurvey = () => {
    let userid = UserObj?.rec_id;
    let authToken = JSON.parse(localStorage.getItem('headData'));

    axios
      .get(
        `${process.env.REACT_APP_API_URL}survey/getSurveyByCompany/${company_id}/${userid}`, {
          headers: {
            Authorization: authToken?.spintlyToken,
          }
        }
      )
      .then(res => {
        if (res.data.statusValue === 200) {
          setSurveyData(res.data.data);
        }
      });
  };

  useEffect(() => {
    getSurvey();
  }, []);

  const getSurveyTitle = (survey) => {
    if (survey.check_move_in === 1) return 'Move-in survey';
    if (survey.check_move_in === 3) return 'Customer Satisfaction Survey';
    if (survey.check_move_in === 2) return 'Move-out Survey';
    return '';
  };

  const getSurveyDescription = (survey) => {
    if (survey.check_move_in === 1) return "We value your opinion! Tell us about your Move-In experience.";
    if (survey.check_move_in === 3) return "Tell us how we're doing: take a moment to rate your experience!";
    if (survey.check_move_in === 2) return "We value your opinion! Tell us about your Move-out experience.";
    return '';
  };

  const getSurveyIcon = (survey) => {
    if (survey.check_move_in === 1) return 'img/move-in-survey-icon.png';
    if (survey.check_move_in === 3) return 'img/newSurveyIcon.svg';
    if (survey.check_move_in === 2) return 'img/move-out-survey-icon.png';
    return '';
  };

  return (
    <Layout>
      <Sidebar collapsed={collapsed} />
      <CustomHeader collapsed={collapsed} toggleCollapsed={toggleCollapsed} />

      <Layout className={collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>
        <div className="PageContent">
          <div className="SurveyManagement_Page">
            <div className="row">
              {surveyData.map((survey, index) => (
                <div className="col-md-7" key={index}>
                  <div
                    className='opinionBanner SurveyBanner'
                    style={{ background: '#EFF4FF' }}
                  >
                    <div>
                      <h2>
                        {getSurveyTitle(survey)}
                        <span className="badge badge-light">
                          <img src='img/location-icon.svg' alt="" className="me-1"/>
                          {survey.locationData.length} {survey.locationData.length > 1 ? 'Locations' : 'Location'} Remaining
                        </span>
                      </h2>
                      <p>{getSurveyDescription(survey)}</p>
                      <SwButton
                        variant="primary"
                        size="sm"
                        onClick={() => setActiveSurveyIndex(index)}
                        icon={<i className="bi bi-arrow-right" />}
                        iconPosition="end"
                      >
                        Start Survey
                      </SwButton>
                    </div>
                    <div className='opinionBannericon'>
                      <img src={getSurveyIcon(survey)} alt="Survey Icon" />
                    </div>
                  </div>
                  <FeedbackRating
                    surveyProps={[survey]}
                    show={activeSurveyIndex === index}
                    onClose={() => setActiveSurveyIndex(null)}
                    apiDataSurvey={getSurvey}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </Layout>
    </Layout>
  );
};

export default SurveyManagement;
